import { useMemo } from 'react';

import { Navigate, Route, Routes, useLocation, useMatch, useSearchParams } from 'react-router-dom';

const RedirectLegacyWalletRoutes = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const walletTicketsRouteMatch = useMatch('/wallet/tickets');
  const walletTicketIdRouteMatch = useMatch('/wallet/tickets/:ticketId');

  const redirectPath = useMemo(() => {
    // Extract the path segment after '/wallet/'
    const pathSegment = location.pathname.split('/wallet/')[1] || '';
    const searchParamString = searchParams.toString();
    const withSearchParams = (path: string) =>
      searchParamString ? `${path}?${searchParamString}` : path;

    // Route mapping: /wallet/* -> new destination
    if (!pathSegment) {
      return withSearchParams('/account');
    }

    if (pathSegment === 'earnings' || pathSegment.startsWith('earnings/')) {
      const rewardsPathSegment = pathSegment.replace(/^earnings/, 'rewards');
      return withSearchParams(`/account/${rewardsPathSegment}`);
    }

    if (pathSegment === 'card') {
      return withSearchParams('/account/card');
    }

    if (walletTicketsRouteMatch) {
      return withSearchParams('/tickets');
    }

    if (walletTicketIdRouteMatch) {
      return withSearchParams(`/tickets/${walletTicketIdRouteMatch.params.ticketId}`);
    }

    // Default: move everything else under /account
    return withSearchParams(`/account/${pathSegment}`);
  }, [location.pathname, searchParams, walletTicketsRouteMatch, walletTicketIdRouteMatch]);

  return <Navigate to={redirectPath} replace />;
};

const WalletRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<RedirectLegacyWalletRoutes />} />
    </Routes>
  );
};

export { WalletRoutes };
